import React, { useMemo } from "react";
import { useTable } from "react-table";
import { Typography } from "components";
import PropTypes from "prop-types";

import "./style.scss";

const Table = ({
  data = [],
  columns = [],
  centerData = false,
  loading,
  isFooter,
  onRowClick,
}) => {
  const tableData = useMemo(() => data, [data]);
  const tableColumns = useMemo(() => columns, [columns]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns: tableColumns,
    data: tableData,
  });

  return (
    <div className={`table-container ${centerData ? "table-center" : ""}`}>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className={`table-row ${onRowClick ? "cursor-pointer" : ""}`}
              >
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      onClick={() =>
                        onRowClick ? onRowClick(cell.row.original) : {}
                      }
                      style={{
                        minWidth: cell.column.customWidth
                          ? cell.column.customWidth
                          : "",
                      }}
                    >
                      {cell.render("Cell")}{" "}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
        {isFooter && (
          <tfoot>
            {footerGroups.map((footerGroup) => (
              <tr {...footerGroups.getFooterGroupProps()}>
                {footerGroup.headers.map((column) => (
                  <td {...column.getFooterProps}>{column.render("Footer")}</td>
                ))}
              </tr>
            ))}
          </tfoot>
        )}
      </table>

      {loading && (
        <Typography variant="body0" className="text-center mt-4">
          Loading...
        </Typography>
      )}

      {!loading && !data.length && (
        <Typography variant="body0" className="text-center mt-4">
          No data avaliable
        </Typography>
      )}
    </div>
  );
};

Table.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array,
  centerData: PropTypes.bool,
  loading: PropTypes.bool,
};

Table.defaultProps = {
  isFooter: false,
};

export default Table;
